/**
 * Create a shallow copy of the values from source to target and remove undefined values.
 * This function is useful for copying values from one object to another, while ignoring undefined values.
 * @param source Object to copy values from
 * @returns Shallow copy of the values from source
 */
export function copyAndCleanValues<T extends object>(source: T): Partial<T> {
  const keys = Object.keys(source) as Array<keyof T>
  const target: Partial<T> = {}
  keys.forEach((key) => {
    if (source[key] !== undefined) {
      target[key] = source[key]
    }
  })
  return target
}
